export default "__VITE_ASSET__691a61a2__"